import React, { useState,useEffect } from 'react'; 
import '../../CSS/Signup.css'
import axios from 'axios'
import validator from 'validator'
import { Link } from 'react-router-dom';
var CryptoJS = require("crypto-js");
const SignupForm = () => { 
      const [email, setEmail] = useState('');
      const [password, setPassword] = useState('');
      const [cpass, setCpass] = useState('');
      const [msg, setMsg] = useState('');
      const [phone, setPhone] = useState('');
      const [checkbox, setCheckBox] = useState(false);
      const [showPassword, setShowPassword] = useState(false);
      const [showPasswordC, setShowPasswordC] = useState(false);

      const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
      };

      const togglePasswordVisibilityC = () => {
        setShowPasswordC(!showPasswordC);
      };

      const handleCreate = ()=>{
            setMsg(<i class="fa fa-circle-o-notch fa-spin mt-2" style={{fontSize:'30px',color:"#000"}}></i>)
            if(email.length>0 && password.length>0 && cpass.length>0){
                if (validator.isStrongPassword(password, {
                  minLength: 8, minLowercase: 1,
                  minUppercase: 1, minNumbers: 1, minSymbols: 1
              })) {
                if(password.length<=100){
                  if(password===cpass){
                  var encryptedemail = CryptoJS.AES.encrypt(email,"key")
                  var encryptedpass = CryptoJS.AES.encrypt(password,"key")
                  axios.post("https://api.mahirefrigeration.com/api/signup",{
                    encryptedemail:encryptedemail.toString(),
                    encryptedpass:encryptedpass.toString(),
                    phone:phone
                  })
                  .then(res=>{
                    if(res.data==='Signup Complete'){
                      setMsg(res.data)
                      setTimeout(()=>{
                            window.location.href="/"
                        },2000)
                    }
                    else{
                      setMsg(res.data)
                    }
                  })
                  .catch(err=>{
                    setMsg("Something Went Wrong")
                  })
                }
                else{
                  setMsg("Password doesn't match")
                }
              }
              else{
                setMsg("Maximum password length is 100")
              }
              }
              else {
                  setMsg("Password must have combination of alphanumeric and special character and should be minimum 8 characters")
            }
            }
            else{
                  setMsg('Please enter all fields correctly!')
            }
        }
	return ( 
    <div className='parent ' style={{position:"relative",height:"100vh"}}>
		<div className='child_class p-4' style={{backgroundcolor:"00",border:"1px solid #252936",color:"#000",borderRadius:"6px"}}> 
    <div className='signup_Text'>
        <span className='' style={{color:"#a0d9ef"}}>Hi!{"\n"} Welcome</span>
        {/* <img src={Logo} style={{width:"50%"}}/> */}
        </div>
        <br/>
        <div style={{textAlign:"left"}}>
        <p>Let's create an account</p>
        </div>
            <div class="form__group field">
            <label for="name" class="form__label">Email</label>
            <input type="input" class="form__field" placeholder="Name" onChange={(e)=>setEmail(e.target.value)}  id='name' required />
            </div>
            <div class="form__group field">
            <label for="name" class="form__label">Phone</label>
            <input type="number" class="form__field" placeholder="Phone" onChange={(e)=>setPhone(e.target.value)} id='name' required />
            </div>
            
            <div class="form__group field">
            <label for="name" class="form__label">Password</label>
            <input type={showPassword?'text':'password'} class="form__field" placeholder="Name" onChange={(e)=>setPassword(e.target.value)} name="name" id='name' required />
            {showPassword?
              <i class="fa fa-eye" onClick={togglePasswordVisibility} style={{position:"absolute",top:"48%",right:"5px",color:"#a0d9ef",cursor:"pointer"}} aria-hidden="true"></i>
              :
              <i class="fa fa-eye-slash" onClick={togglePasswordVisibility} style={{position:"absolute",top:"48%",right:"5px",color:"#a0d9ef",cursor:"pointer"}} aria-hidden="true"></i>
          }
            </div>
            <div class="form__group field">
            <label for="name" class="form__label">Confirm Password</label>
            <input type={showPasswordC?'text':'password'} class="form__field" placeholder="Name" onChange={(e)=>setCpass(e.target.value)} name="name" id='name' required />
            {showPasswordC?
              <i class="fa fa-eye" onClick={togglePasswordVisibilityC} style={{position:"absolute",top:"48%",right:"5px",color:"#a0d9ef",cursor:"pointer"}} aria-hidden="true"></i>
              :
              <i class="fa fa-eye-slash" onClick={togglePasswordVisibilityC} style={{position:"absolute",top:"48%",right:"5px",color:"#a0d9ef",cursor:"pointer"}} aria-hidden="true"></i>
          }
            </div>
            <div class="form__group" style={{display:"flex",justifyContent:"left"}}>
            <input type="checkbox" onClick={() => setCheckBox(!checkbox)}/> &nbsp;
                      <label
                        class="form-check-label"
                        for="flexCheckDefault"
                        style={{ color: "" }}
                      >
                        Sign up apply to the acceptance of our Terms and Conditions.
                      </label>
            </div>
            <div class="form__group field">
              {
                checkbox?
                <button type="button" class="btn" onClick={handleCreate} style={{minWidth:"50%",border:"1px solid #a0d9ef",backgroundColor:"#fff",color:"#000"}}>Signup</button>
                :
                <button type="button" class="btn" style={{minWidth:"50%",border:"1px solid #000",backgroundColor:"#fff",color:"#000"}} disabled>Signup</button>
              }
            {/* <button type="button" class="btn btn-lg w-100 color_button" onClick={handleCreate}>Signup</button> */}
            <br/>
            <p>{msg}</p>
            <br/>
            <p>Have an account?<Link to="/signin" style={{textDecoration:"none",color:"#000"}}><span style={{fontWeight:"800",color:"#a0d9ef"}}> Login</span></Link></p>
            </div>
		</div> 
    </div>
	); 
} 
export default SignupForm;